import React from "react";
import PayrollRomms from "../../payroll/PayrollRomms";

interface GoingConcernRommsProps {
  onBack: () => void;
}

export default function GoingConcernRomms({ onBack }: GoingConcernRommsProps) {
  return <PayrollRomms onBack={onBack} onComplete={() => {}} workspace="Going Concern" />;
}
